import { useEffect, useState } from "react";
import { api } from "../../lib/apiClient";
import { PageHead, Card, Kpi, Pill, Loading, Err } from "./_shared";

export default function Usage() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/api/admin/usage/global").then(setData).catch((e) => setErr(e.message)); }, []);
  if (err) return <Err msg={err} />;
  if (!data) return <Loading />;

  return (
    <div data-testid="admin-usage">
      <PageHead title="Platform usage" sub="Aggregate AI job activity across all workspaces" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 12 }}>
        <Kpi label="Jobs today"  value={data.today_jobs} />
        <Kpi label="Total jobs"  value={data.total_jobs} sub="lifetime" />
      </div>
      <div style={{ marginTop: 18, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>
        <BreakdownCard title="By job type"  items={data.by_type} />
        <BreakdownCard title="By status"    items={data.by_status} tone="status" />
        <BreakdownCard title="By provider"  items={data.by_provider} />
      </div>
    </div>
  );
}

function BreakdownCard({ title, items, tone }) {
  const total = (items || []).reduce((s, x) => s + (x.count || 0), 0) || 1;
  return (
    <Card title={title}>
      {(items || []).length === 0 ? (
        <div style={{ color: "var(--pl-text-muted)", fontSize: 12 }}>No data yet.</div>
      ) : (items || []).map((x) => {
        const pct = Math.round((x.count / total) * 100);
        return (
          <div key={x.key} style={{ marginBottom: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                {tone === "status" ? <Pill tone={statusTone(x.key)}>{x.key}</Pill> : <span style={{ fontSize: 12, fontWeight: 700 }}>{x.key}</span>}
              </div>
              <span style={{ fontFamily: "JetBrains Mono, monospace", fontWeight: 800, fontSize: 12 }}>{x.count} · {pct}%</span>
            </div>
            <div style={{ height: 6, borderRadius: 999, background: "var(--pl-bg-2)", overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${pct}%`, background: "linear-gradient(90deg, var(--pl-aqua), #B9FF2F)" }} />
            </div>
          </div>
        );
      })}
    </Card>
  );
}

function statusTone(s) {
  return ({ succeeded: "success", failed: "danger", queued: "aqua", running: "aqua", canceled: "warn", retrying: "warn" }[s]) || "muted";
}
